import React from 'react';
import { Participation, useParticipationIncentiveText } from '@app/api';
import { IconChip } from '@app/core';
import { Colors, theme } from '@app/theme';
import useMediaQuery from '@mui/material/useMediaQuery';

interface Props {
  participation: Participation;
  color?: Colors;
}

export const IncentiveChip = ({ participation, color }: Props) => {
  const shortIncentive = useMediaQuery(theme.media.tablet);

  const incentive = useParticipationIncentiveText(
    participation,
    participation.session,
    undefined,
    shortIncentive,
  );

  if (!incentive) {
    return null;
  }

  return (
    <IconChip icon="ri-coins-line" color={color || 'green'} label={incentive} />
  );
};
